import React from 'react';

import { Button } from 'reactstrap';
import { RecordState } from 'constants/constants';

const RecordingControls = ({
  recordState,
  isLoadingPreview,
  isReviewing,
  startRecording,
  cancelRecording,
  stopRecording,
  reset,
}) => {
  const renderRecordingControl = React.useCallback(() => {
    if (isReviewing) {
      return null;
    } else if (recordState === RecordState.IDLE) {
      return (
        <Button.Ripple
          className="mr-2 round"
          color="info"
          type="secondary"
          onClick={startRecording}
        >
          Start recording
        </Button.Ripple>
      );
    } else if (recordState === RecordState.PREPARING) {
      return (
        <Button.Ripple
          className="mr-2 round"
          color="info"
          type="secondary"
          onClick={cancelRecording}
        >
          Cancel recording
        </Button.Ripple>
      );
    } else if (RecordState.RECORDING) {
      return (
        <Button.Ripple
          className="mr-2 round"
          color="info"
          type="secondary"
          onClick={stopRecording}
        >
          Stop recording
        </Button.Ripple>
      );
    }
  }, [
    isReviewing,
    recordState,
    startRecording,
    cancelRecording,
    stopRecording,
  ]);

  return (
    <div className="container">
      <div className="containerBtn">
        {renderRecordingControl()}
        <Button.Ripple type="button" onClick={reset} className="round">
          Reset
        </Button.Ripple>
      </div>
      <style jsx>
        {`
          .container {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }

          .containerBtn {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
          }
        `}
      </style>
    </div>
  );
};

export default RecordingControls;
